import { RadioGroup } from '@/components/ui/radio-group';
import { PayoutAccount, PayoutAccountStatus } from '@/types/api/payout-account';
import { PayoutAccountListItem } from './payout-account-list-item';
import { useModal } from '@/hooks/shared/use-modal';
import { ModalType } from '@/types/stores/modal';

interface PayoutAccountsProps {
  accounts: Array<PayoutAccount>;
}

export function PayoutAccountList({ accounts }: PayoutAccountsProps) {
  const activeAccount = accounts.find((a) => a.status === PayoutAccountStatus.Active)!;
  const { open } = useModal();

  return (
    <div>
      {accounts.length ? (
        <RadioGroup
          onValueChange={(accountId) => {
            open(ModalType.ActivatePayoutAccount, { account: accounts.find((a) => a.id === accountId)! });
          }}
          value={activeAccount.id}
          className="gap-2 grid grid-cols-6"
          defaultValue={activeAccount.id}
        >
          {accounts.map((account) => (
            <PayoutAccountListItem {...account} />
          ))}
        </RadioGroup>
      ) : (
        <div className="size-full flex items-center justify-center">
          <p className="text-sm font-normal my-6">Inga konton registerade</p>
        </div>
      )}
    </div>
  );
}
